<template>
	<div class="changeInte">
		<div class="breadcrumb">替换奖品
			<el-button class="right_f" type="primary" @click="save">保存</el-button>
			<el-button class="right_f" type="primary" @click="back">取消</el-button>
		</div>

		<div>
			<el-form ref="inteForm" :rules="rules" :model="inteForm" label-width="130px">
				<el-form-item label="替换序号：" prop="position" required>
					<el-select v-model="inteForm.position" style="width: 150px;">
						<el-option :label="index + 1" :value="index + 1" v-for="(item,index) in 8"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="奖品名称：" prop="prizeName">
					<el-input v-model="inteForm.prizeName" placeholder="请输入奖品名称" class="inputTitle"></el-input>
				</el-form-item>
				<el-form-item label="奖品图片：" prop="imgUrl" required>
					<el-upload :action="logoActionUrl" :with-credentials='true' accept="image/*" name="uploadFile" type="drag" :thumbnail-mode="true"
					 :on-error="handleError" :on-success="handleSuccess">
						<i class="el-icon-upload"></i>
						<div class="el-dragger__text">将文件拖到此处，或
							<em>点击上传</em>
						</div>
					</el-upload>
					<span class="gray">（尺寸说明：360×300像素，jpg、jpeg、png）</span>
				</el-form-item>

				<el-form-item label="奖品库存：" prop="fileUrl">
					<el-upload :action="importAction" :with-credentials='true' style="display: inline-block" :on-success="success" :on-error="handleError"
					 name="uploadFile">
						<el-button>选择文件</el-button>
					</el-upload>
				</el-form-item>

				<el-form-item label="可中奖次数：" required>
					<el-radio v-model="inteForm.isLimit" label="0">不限</el-radio>
					<el-radio v-model="inteForm.isLimit" label="1" class="inline">限定</el-radio>
					<br>
					<el-input v-model="inteForm.drawHitCount" v-if='inteForm.isLimit=="1"' placeholder="请输入自定义数量" style="width: 250px;" class="probability">
						<template slot="append" style="line-height: 34px;">次</template>
					</el-input>
				</el-form-item>

				<el-form-item label="自动兑奖：" required>
					<el-radio v-model="inteForm.isAuto" label="1">是</el-radio>
					<el-radio v-model="inteForm.isAuto" label="0" class="inline">否</el-radio>
				</el-form-item>

				<el-form-item label="是否无限：" required>
					<el-radio v-model="inteForm.isInfinite" label="1">是</el-radio>
					<el-radio v-model="inteForm.isInfinite" label="0" class="inline">否</el-radio>
				</el-form-item>

				<el-form-item label="兑奖URL：" prop="prizeUrl" required>
					<el-radio v-model="inteForm.definePrizeUrl" label="false">不跳转</el-radio>
					<el-radio v-model="inteForm.definePrizeUrl" label="true" class="inline">自定义URL</el-radio>
					<el-input v-model="inteForm.prizeUrl" v-if='inteForm.definePrizeUrl=="true"' class="inputTitle"></el-input>
				</el-form-item>

				<el-form-item label="广告曝光代码：" prop="adExposingCodes" class="prizeContent">
					<el-input type="textarea" :autosize="{minRows: 5}" placeholder="请输入广告曝光代码" v-model="inteForm.adExposingCodes">
					</el-input>
				</el-form-item>

				<el-form-item label="文案类型：" class="prizeContent" required>
					<el-radio v-model="inteForm.isRedeem" label="1">兑奖码类型</el-radio>
					<el-radio v-model="inteForm.isRedeem" label="0" class="inline">自定义文案</el-radio>
				</el-form-item>

				<el-form-item label="文案：" prop="defineText" class="prizeContent">
					<el-input type="textarea" :autosize="{minRows: 5}" placeholder="请输入文案" v-model="inteForm.defineText">
					</el-input>
				</el-form-item>

				<el-form-item prop="startTime" class="time" label="兑换开始时间：">
					<el-date-picker v-model="inteForm.startTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate"></el-date-picker>
				</el-form-item>

				<el-form-item prop="endTime" class="time" label="兑换结束时间：">
					<el-date-picker v-model="inteForm.endTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate"></el-date-picker>
				</el-form-item>

				<select-school :schObj="inteForm.schObj" @changeVal="getVal"></select-school>

				<el-form-item prop="replaceStartTime" class="time" label="替换开始时间：">
					<el-date-picker v-model="inteForm.replaceStartTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate"></el-date-picker>
				</el-form-item>

				<el-form-item prop="replaceEndTime" class="time" label="替换结束时间：">
					<el-date-picker v-model="inteForm.replaceEndTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd" class="qizhiDate"></el-date-picker>
				</el-form-item>

			</el-form>

		</div>

	</div>
</template>
<script>
	import { mapState, mapActions } from "vuex";
	import selectSchool from "../../common/selectSch.vue"

	export default {
		data() {
			let checkStartTime = (rule, value, callback) => {
				if (value === "") {
					callback(new Error("请输入替换开始时间"));
				} else {
					let tomorrow =
						new Date(new Date().format("yyyy/MM/dd 00:00:00")).getTime() +
						24 * 60 * 60 * 1000;

					if (value < tomorrow) {
						callback(new Error("替换开始时间最小为明天"));
					} else {
						callback();
					}
				}
			};

			let checkEndTime = (rule, value, callback) => {
				if (value === "") {
					callback(new Error("请输入替换结束时间"));
				} else {
					let tomorrow =
						new Date(new Date().format("yyyy/MM/dd 00:00:00")).getTime() +
						24 * 60 * 60 * 1000;

					if (value < tomorrow) {
						callback(new Error("替换结束时间最小为明天"));
					} else {
						callback();
					}
				}
			};
			return {
				operatorId: this.$store.state.user.userId,
				operator: this.$store.state.user.name,
				importAction:
					this.$util.domain +
					"/adminapi/v1/basicTools/upload/one?uploadImageType=7",
				logoActionUrl:
					this.$util.domain +
					"/adminapi/v1/basicTools/upload/one?uploadImageType=7",
				dataList: [],
				inteForm: {
					position: this.$util.getUrlParam("position")
						? this.$util.getUrlParam("position") * 1
						: 1,
					prizeName: "",
					probability: "",
					prizeUrl: "",
					adExposingCodes: "",
					defineText: "",
					replaceStartTime: "",
					replaceEndTime: "",
					startTime: "",
					endTime: "",
					drawHitCount: "",
					isRedeem: "0",
					schObj: {
						applicableCampus: "0",
						shieldedSchools: [],
						openedSchools: []
					},
					isAuto: "1",
					isInfinite: "0",
					isLimit: "0",
					definePrizeUrl: "false"
				},
				rules: {
					prizeName: [
						{ required: true, message: "请填写奖品名称", trigger: "blur" }
					],
					imgUrl: [
						{ required: true, message: "请上传奖品图片", trigger: "change" }
					],
					probability: [
						{
							required: true,
							type: "number",
							message: "请正确填写中奖概率",
							trigger: "blur"
						}
					],
					fileUrl: [{ required: true, message: "请导入奖品", trigger: "change" }],
					startTime: [
						{
							type: "date",
							required: true,
							message: "请选择兑换开始时间",
							trigger: "change"
						}
					],
					endTime: [
						{
							type: "date",
							required: true,
							message: "请选择兑换结束时间",
							trigger: "change"
						}
					],
					replaceStartTime: [
						{
							type: "date",
							required: true,
							message: "请选择替换开始时间",
							trigger: "change"
						},
						{
							validator: checkStartTime
						}
					],
					replaceEndTime: [
						{
							type: "date",
							required: true,
							message: "请选择替换结束时间",
							trigger: "change"
						},
						{
							validator: checkEndTime
						}
					]
				}
			};
		},
		components: { selectSchool },
		mounted() {
			this.dataList = JSON.parse(this.$util.getStore("prizeList"));
		},
		methods: {
			//获取子组件传递的参数
			getVal(res) {
				this.inteForm.schObj = res;
			},
			//保存
			save() {
				//进行表单校验
				if (
					this.inteForm.schObj.applicableCampus == "1" &&
					this.inteForm.schObj.openedSchools.length == 0
				) {
					this.$util.errorMsg("请添加应用学校");
					return;
				}

				//校验成功，调用添加方法；
				this.$refs.inteForm.validate(valid => {
					if (valid) {
						//提交请求
						this.submit();
					}
				});
			},
			submit() {
				let startTime = "",
					endTime = "",
					replaceStartTime = "",
					replaceEndTime = "",
					drawHitCount = 0;

				if (
					this.inteForm.definePrizeUrl == "true" &&
					!this.inteForm.prizeUrl.length
				) {
					this.$util.errorMsg("请填写自定义url");
					return;
				}

				if (this.inteForm.definePrizeUrl == "false") {
					this.inteForm.prizeUrl = "";
				}

				if (
					this.inteForm.applicableCampus == "1" &&
					this.inteForm.openedSchools.length == 0
				) {
					this.$util.errorMsg("请添加应用学校");
					return;
				}

				let campusList = [], schObj = this.inteForm.schObj;
				if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
					for (let i = 0; i < schObj.shieldedSchools.length; i++) {
						campusList.push(schObj.shieldedSchools[i].rootUnid * 1);
					}
				} else if (schObj.applicableCampus == 1 && schObj.openedSchools.length) {
					for (let i = 0; i < schObj.openedSchools.length; i++) {
						campusList.push(schObj.openedSchools[i].rootUnid * 1);
					}
				}

				startTime = new Date(
					new Date(this.inteForm.startTime).format("yyyy-MM-dd 00:00:00")
				).getTime();
				endTime = new Date(
					new Date(this.inteForm.endTime).format("yyyy-MM-dd 23:59:59")
				).getTime();

				replaceEndTime = new Date(
					new Date(this.inteForm.replaceEndTime).format("yyyy-MM-dd 23:59:59")
				).getTime();
				replaceStartTime = new Date(
					new Date(this.inteForm.replaceStartTime).format("yyyy-MM-dd 00:00:00")
				).getTime();

				if (replaceStartTime >= replaceEndTime) {
					this.$util.errorMsg("请正确填写替换开始时间与结束时间");
					return;
				}

				if (this.inteForm.isLimit == "0") {
					drawHitCount = -1; //不限次数
				} else {
					drawHitCount = this.inteForm.drawHitCount;
				}

				let url = this.$util.domain + "/adminapi/v2/rounddisk/replace/save";

				this.$http({
					url,
					method: "POST",
					headers: {
						operatorId: this.operatorId + ""
					},
					body: JSON.stringify({
						position: this.inteForm.position,
						prizeName: this.inteForm.prizeName,
						imgUrl: this.inteForm.imgUrl,
						fileUrl: this.inteForm.fileUrl,
						drawHitCount: drawHitCount * 1,
						definePrizeUrl: this.inteForm.definePrizeUrl,
						prizeUrl: this.inteForm.prizeUrl,
						adExposingCodes: this.inteForm.adExposingCodes,
						isRedeem: this.inteForm.isRedeem * 1,
						defineText: this.inteForm.isRedeem == 1 ? '' : this.inteForm.defineText,
						redeemText: this.inteForm.isRedeem == 1 ? this.inteForm.defineText : '',
						startTime: startTime,
						endTime: endTime,
						isAuto: this.inteForm.isAuto * 1,
						isInfinite: this.inteForm.isInfinite * 1,
						applicableCampus: schObj.applicableCampus,
						campusList: campusList,
						replaceStartTime: replaceStartTime,
						replaceEndTime: replaceEndTime
					})
				}).then(response => {
					if (response.data.error == 10000) {
						this.$util.successMsg("替换成功");

						this.dataList.forEach(item => {
							if (item.position == this.inteForm.position) {
								item.hasReplacePrize = true;
							}
						});

						this.$util.setStore("prizeList", this.dataList);
						this.cancel();
					} else {
						this.$util.errorMsg(response.data.message);
					}
				});
			},
			back() {
				this.$confirm(`取消添加将不保存编辑记录，是否继续取消`, "提示", {
					confirmButtonText: "是",
					cancelButtonText: "否",
					type: "warning"
				})
					.then(() => {
						this.cancel();
					})
					.catch(() => { });
			},
			cancel() {
				location.href = "/#/yunying/integration/integration?isFirst=1";
			},
			//上传picture文件成功钩子
			handleSuccess(response) {
				if (response.error !== 10000) {
					this.$util.errorMsg("上传失败");
				} else {
					this.$util.successMsg("导入成功");
					this.inteForm.imgUrl = response.data;
				}
			},
			success(response) {
				if (response.error !== 10000) {
					this.$util.errorMsg("上传失败");
				} else {
					this.$util.successMsg("导入成功");
					this.inteForm.fileUrl = response.data;
				}
			},
			//上传文件失败钩子
			handleError(response) {
				if (response.status === 403) {
					this.SIGNOUT();
					location.href = "/#";
				}
				this.$util.errorMsg("上传失败");
			}
		}
	};
</script>

<style>
	.inputTitle {
		width: 40%;
	}

	.qizhiDate {
		display: inline-block;
		width: 100%;
	}

	.changeInte .time {
		width: 40%;
	}

	.changeInte .irregular {
		display: inline-block;
	}

	.gray {
		color: #999;
	}

	.probability .el-input__inner {
		height: 38px;
	}

	.changeInte .el-input-group__append {
		line-height: 34px;
		height: 34px;
	}
</style>


// WEBPACK FOOTER //
// changeIntegration.vue?1e389b89